<template>
    <div class="login">
        <div class="header">
            <div class="title">电力能源互联网平台</div>
            <p>让能源利用更安全、更简单</p>
        </div>
         <div class="box">
            <div class="title">欢迎使用！</div>
            <div class="submitForm">
                <el-input
                    placeholder="请输入手机号"
                    v-model="tel">
                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                </el-input>
                <el-input
                    placeholder="请输入密码"
                    type="password"
                    v-model="psw">
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
                <el-button type="primary" class="submit" @click="onSubmit">登 录</el-button>
            </div>
         </div>
    </div>
</template>

<script>
import { login } from '../../api/power.js'
export default {
  data() {
    return {
        tel: '',
        psw: ''
    }
  },
  methods: {
    async onSubmit() {
        // if(this.tel==""){
        //     this.$message.error("请输入手机号")
        //     return false
        // }
        var phoneReg = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
        if (this.tel === '') {
            this.$message.error("请输入手机号")
            return false
        } else {
            if (!phoneReg.test(this.tel)) {
                this.$message.error('手机号格式错误');
                return false
            }
        }
        if(this.psw==""){
            this.$message.error("请输入密码")
            return false
        }
        let res = await login({
            tel:this.tel,
            psw:this.psw
        })
        if(res.data.status){
            this.$message.success("登录成功！")
            this.$router.push("/Index")
        }else{
            this.$message.error("账号或者密码错误，请重新输入")
        }
      }
    }
}
</script>

<style scoped lang="less">
    .login{
        background: url("../../assets/img/login.png") no-repeat;
        background-size: 100% 100%;
        position: fixed;
        width: 100%;
        height: 100%;
        .header{
            width: 631px;
            height: 437px;
            position: absolute;
            top: 16%;
            right: 10%;
            text-align: center;
            color: #fff;
            .title{
                font-size: 48px;
                // font-weight: bold;
                letter-spacing: 18px;
                font-family: "YouSheBiaoTiHei";
                text-shadow: 0 0 10px #20a3f5, 0 0 20px #20a3f5, 0 0 30px #20a3f5;
            }
            p{
                color:#41acd2;
                font-size: 20px;
                margin-top: 20px;
                letter-spacing: 10px;
            }
        }
        .box{
            background: url("../../assets/img/bom.png") no-repeat;
            width: 631px;
            height: 437px;
            position: absolute;
            top: 32%;
            right: 10%;
            padding:40px 50px;
            .title{
                color:#41acd2;
                font-size: 20px;
                margin-bottom: 20px;
            }
            /deep/.submitForm {
                .el-input{
                    margin-top: 20px;
                }
                .el-input__inner{
                    border: 3px solid #2074ab;
                    height: 55px;
                    border-radius: 0 !important;
                    font-size: 16px;
                    background: rgba(26 ,107, 160 ,0.4);
                    padding-left: 60px;
                    color:#fff
                }
                .el-input__prefix{
                    font-size: 25px;
                    color:#41acd2;
                    width: 62px;
                    line-height: 50px;
                    top: 2px;
                }
                .submit{
                    margin-top: 35px;
                    width: 100%;
                    height: 48px;
                    border: 0;
                    font-weight: bold;
                    font-size: 18px;
                    background:linear-gradient(90deg, #5de3dd 0%, #068bdf 100%);
                }
            }
        }
    }
</style>